export default function Version() {
    return (
        <>
            <small className="text-white">v1.3</small>
        </>
    )
}